import data from "@emoji-mart/data";
import { Amplify } from "aws-amplify";
import { init } from "emoji-mart";
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Toaster } from "sonner";
import App from "./App.tsx";
import config from "./aws-exports";
import DebugKeyListener from "./common/DebugModeKeyListener/index.tsx";
import { initAuthenticatorI18n } from "./constants/authenticatorI18n";
import { TOAST_CONFIG } from "./constants/toastConfig";
import { getAppVersion, getCommitHash } from "./utils/versionUtils";
import "./index.css";

init({ data });

initAuthenticatorI18n();
Amplify.configure(config);

// バージョン情報をコンソールに出力
console.info(`Version: ${getAppVersion()} (${getCommitHash()})`);

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <DebugKeyListener />
      <App />
      <Toaster {...TOAST_CONFIG} />
    </BrowserRouter>
  </React.StrictMode>
);
